import Component from "@glimmer/component";
import { LinkTo } from "@ember/routing";
import { getAutoRoutes, type AutoRoute, type AutoRouteId } from "#utils/auto-routes.ts";

export interface AutoRouteNavSignature {
  Element: HTMLElement;
  Args: {
    id: AutoRouteId;
    includeIndex?: boolean;
  };
  Blocks: {
    default: [route: AutoRoute, allroutes: AutoRoute[]];
  };
}

export default class AutoRouteNav extends Component<AutoRouteNavSignature> {
  get routes(): AutoRoute[] {
    return getAutoRoutes(this.args.id, {
      includeIndex: this.args.includeIndex ?? false,
    });
  }

  <template>
    <nav ...attributes>
      {{#each this.routes as |route|}}
        {{#if (has-block)}}
          {{yield route this.routes}}
        {{else}}
          <LinkTo
            @route={{route.name}}
            class="text-blue-600 underline hover:text-blue-800 [&.active]:no-underline"
          >
            {{route.title}}
          </LinkTo>
        {{/if}}
      {{/each}}
    </nav>
  </template>
}
